import React, { useState, useEffect } from "react";
import { Table } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useReportsStore } from "../../store/slices/createReportsSlice";
import { usePersistedStore } from "../../store/persisted-store";

const columns = [
    {
        title: "ردیف",
        dataIndex: "Id",
        width: 100,
        key: "Id",
        render: data => strings.getFarsiNum(data),
    },
    {
        title: "مبلغ کل",
        dataIndex: "Amount",
        width: 150,
        key: "Amount",
        render: data => <span style={data > 0 ? { color: '#5ec393' } : { color: '#ff001e' }} > {strings.currencyFormat(data) + ' ریال'}</span >
    },
    {
        title: "توضیحات",
        dataIndex: "Description",
        ellipsis: true,
        key: "Description",
        render: data => strings.getFarsiNum(data),
    },
    {
        title: "تاریخ",
        dataIndex: "Date",
        width: 150,
        key: "Date",
        render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')),
    }
];

export default function MarketerBalanceTable() {
    const reports = useReportsStore()
    const data = reports.balance.data;
    const loading = reports.balance.loading;
    const { business } = usePersistedStore();
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const customLoading = <div className="spinner-border text-info m-1" role="status">
        <span className="sr-only">در حال بارگذاری...</span>
    </div>

    return (
        <Table
            className="custom-table"
            bordered
            rowKey="Id"
            style={{ overflowX: 'scroll' }}
            scroll={true}
            size="medium"
            columns={columns}
            loading={{
                indicator: { customLoading }, spinning: loading,
            }}
            dataSource={data}
            pagination={false}
            footer={pageData => {
                let totalAmount = null;
                pageData.forEach(({ Amount }) => {
                    totalAmount += Amount;
                });
                return <div><span>مجموع مبلغ : </span>{totalAmount && <span style={totalAmount > 0 ? { color: '#5ec393' } : { color: '#ff001e' }}>{strings.currencyFormat(totalAmount)} ريال</span>}</div>
            }}
        />
    );
}
